import { Directive, ElementRef, HostListener, AfterViewInit, Input, inject, DOCUMENT } from '@angular/core';
import isUndefined from 'lodash/isUndefined';

@Directive({
  selector: '[irisDraggable]',
  standalone: false,
})
export class IrisDraggableDirective implements AfterViewInit {
  elem = inject(ElementRef);
  private readonly document = inject<Document>(DOCUMENT);

  @Input() enableDrag = true;
  @Input() target: string;

  private element: HTMLElement;
  private topStart: number;
  private leftStart: number;
  private isDraggable: boolean;
  private handleElement: HTMLElement;
  private boundingLeft: number;
  private boundingTop: number;

  get windowHeight() {
    return window.innerHeight;
  }

  get windowWidth() {
    return window.innerWidth;
  }

  get handlerHeight() {
    return this.handleElement?.clientHeight;
  }

  get handlerWidth() {
    return this.handleElement?.clientWidth;
  }

  ngAfterViewInit() {
    this.handleElement = this.elem.nativeElement;

    if (!this.target) {
      this.element = this.handleElement;
    } else {
      const elems = Array.from(this.document.querySelectorAll(this.target));
      this.element = elems[elems.length - 1] as HTMLElement;
    }

    if (this.element) {
      this.handleElement.style.cursor = 'grab';
      this.element.style.position = 'relative';
    }
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    if (event.button === 2 || (this.handleElement && event.target !== this.handleElement)) {
      return;
    }

    this.isDraggable = true;

    this.topStart = event.clientY - Number(this.element.style.top.replace('px', ''));
    this.leftStart = event.clientX - Number(this.element.style.left.replace('px', ''));

    event.preventDefault();

    if (isUndefined(this.boundingTop) && isUndefined(this.boundingLeft)) {
      const boundingRect = this.element.getBoundingClientRect();
      this.boundingLeft = boundingRect.left;
      this.boundingTop = boundingRect.top;
    }
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(event: MouseEvent) {
    this.isDraggable = false;
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (!this.isDraggable || !this.enableDrag) { return; }

    const top = event.clientY - this.topStart;
    const left = event.clientX - this.leftStart;

    this.element.style.top = `${top}px`;
    this.element.style.left = `${left}px`;

    const boundingRect = this.element.getBoundingClientRect();

    if (boundingRect.top < 0) {
      this.element.style.top = `${-this.boundingTop}px`;
    }

    if (boundingRect.top > this.windowHeight - this.handlerHeight) {
      this.element.style.top = `${this.windowHeight - this.handlerHeight - this.boundingTop}px`;
    }

    if (boundingRect.left < 0) {
      this.element.style.left = `${-this.boundingLeft}px`;
    }

    if (boundingRect.left > this.windowWidth - this.handlerWidth) {
      this.element.style.left = `${this.windowWidth - this.handlerWidth - this.boundingLeft}px`;
    }
  }

  @HostListener('document:mouseleave', ['$event'])
  onMouseLeave(event: MouseEvent) {
    this.isDraggable = false;
  }

}
